import React from 'react';

type Props = {
  startOverflow: boolean;
  endOverflow: boolean;
  widthPercentage: number;
};

export const CellSpanContent: React.FC<Props> = ({
  startOverflow,
  endOverflow,
  widthPercentage,
  children,
}) => {
  return (
    <div
      style={{
        flex: 1,
        marginLeft: startOverflow ? `-${widthPercentage}%` : undefined,
        marginRight: endOverflow ? `-${widthPercentage}%` : undefined,
      }}>
      {children}
    </div>
  );
};
